module.exports = __webpack_public_path__ + "media/mob.d42fe9c2.mp4";